import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import ViewCostCenterAllocationDetail from "./ViewCostCenterAllocationDetail";

function NewCostCenterAllocation() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Cost Center Allocation Detail</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <ViewCostCenterAllocationDetail />
      </div>
    </div>
  );
}

export default NewCostCenterAllocation;